import {AuthUser} from "../../context/AuthContext";
import {EventStatistics} from "../drinkService";
import GRPC_BACKEND_URL from "../../grpcConfig";
import {normalizeEventStatisticsResponse} from "./utils/normalization";

export const fetchEventStatistics = async (
    eventId: number,
    user?: AuthUser
): Promise<EventStatistics> => {
    const baseUrl = GRPC_BACKEND_URL.replace(/\/$/, "");
    const params = new URLSearchParams();

    if (user) {
        params.set("userId", String(user.userId));
    }

    const query = params.toString() ? `?${params.toString()}` : "";
    const url = `${baseUrl}/api/events/${eventId}/stats${query}`;

    const response = await fetch(url, {
        method: "GET",
        headers: {
            Accept: "application/json",
        },
    });

    if (!response.ok) {
        const body = await response.text();
        const details = body || `Unable to load statistics (status ${response.status})`;
        throw new Error(details);
    }

    const raw = await response.json();
    return normalizeEventStatisticsResponse(raw);
};

